import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthShell } from './LoginPage.jsx';
import { Button, Input, Spinner } from '../../components/ui.jsx';
import { api } from '../../api.js';
import { useAuthStore } from '../../store.js';

export default function AcceptInvitationPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const loadMe = useAuthStore(s => s.loadMe);

  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!token) {
    return <AuthShell><p className="text-sm text-danger">Missing invitation token.</p></AuthShell>;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      await api.magicLinkVerify({ token, new_password: password });
      await loadMe();
      navigate('/dashboard?welcome=1');
    } catch (err) { setError(err.message); setLoading(false); }
  };

  return (
    <AuthShell>
      <h1 className="text-2xl font-semibold text-ink-900 mb-1">Welcome to Skillbase</h1>
      <p className="text-sm text-ink-500 mb-6">Set a password to activate your account.</p>
      <form onSubmit={onSubmit} className="space-y-4">
        <Input label="Password" type="password" required value={password} onChange={e => setPassword(e.target.value)} hint="12+ chars, mixed case, number, symbol" />
        {error ? <p className="text-sm text-danger">{error}</p> : null}
        <Button type="submit" loading={loading} className="w-full" size="lg">Activate account</Button>
      </form>
      <div className="mt-6 p-4 rounded-lg bg-primary-50/60 text-xs text-ink-600 leading-relaxed">
        <strong className="text-ink-900">Privacy reminder:</strong> Your individual answers are private to you. Your manager and HR see aggregated team-level data, not your specific responses.
      </div>
    </AuthShell>
  );
}
